import { render, staticRenderFns } from "./ReadAllTermsAndConditions.vue?vue&type=template&id=6f11b68c"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports